import { createLoadingType } from '../actionHelpers';

export const APP_LOADING = createLoadingType('APP_LOADING');
